import { useEffect, useState } from 'react';
import { BRANDING_PATH, FALLBACK_BRANDING, loadBranding, readCachedBranding } from '../../lib/signInBranding';

export default function TenantBrand({ endpoint = BRANDING_PATH, fallbackBrandName = FALLBACK_BRANDING.brand_name, platformName = null }) {
    const key = `sign-in-branding:${endpoint}`;
    const [branding, setBranding] = useState(() => readCachedBranding(key, { logo_url: null, brand_name: fallbackBrandName }));
    const [failedLogo, setFailedLogo] = useState(null);
    useEffect(() => {
        if (platformName) return undefined;
        const controller = new AbortController();
        loadBranding(endpoint, controller.signal).then((value) => {
            setBranding(value);
            try { window.localStorage.setItem(key, JSON.stringify(value)); }
            catch (error) { console.warn('Sign-in branding could not be cached:', error.message); }
        }).catch((error) => {
            if (error.name !== 'AbortError') console.warn(error.message);
        });
        return () => controller.abort();
    }, [endpoint, key, platformName]);
    // The platform door has no tenant logo; showing the tenant's branding there is the bug this prop prevents.
    if (platformName) return <header className="tenant-brand"><p style={{ fontSize: 26, fontWeight: 700, textAlign: 'center', margin: '0 0 20px' }}>{platformName}</p></header>;
    return <header className="tenant-brand">
        {branding.logo_url && failedLogo !== branding.logo_url && <img
            src={branding.logo_url} alt={`${branding.brand_name} logo`}
            onError={() => setFailedLogo(branding.logo_url)}
            style={{ height: 108, maxWidth: '100%', objectFit: 'contain', margin: '0 auto 12px', display: 'block' }} />}
        <p style={{ fontSize: 26, fontWeight: 700, textAlign: 'center', margin: '0 0 20px' }}>{branding.brand_name}</p>
    </header>;
}
